/**
 * Master-data screens. Only masters the field app or the admin actually use exist — the
 * hierarchy mirrors bovid-api/src/modules/master-data. Locations share one page
 * (LocationMasterPage), animal categories, types and breeds another (AnimalMasterPage).
 */
export interface MasterDefinition {
  /** URL segment under /masters and API resource name. */
  key: string;
  label: string;
  /** Key of the master these records sit under (filter and create-under). */
  parent?: string;
}

export const MASTERS = [
  { key: 'animal-categories', label: 'Animal Categories' },
  { key: 'animal-breeds', label: 'Animal Breeds', parent: 'animal-categories' },
  { key: 'animal-types', label: 'Animal Types', parent: 'animal-categories' },
  { key: 'states', label: 'State' },
  { key: 'districts', label: 'District', parent: 'states' },
  { key: 'mandals', label: 'Mandal', parent: 'districts' },
  { key: 'villages', label: 'Village', parent: 'mandals' },
  { key: 'hamlets', label: 'Hamlet', parent: 'villages' },
] as const satisfies readonly MasterDefinition[];

export type MasterKey = (typeof MASTERS)[number]['key'];

export function masterPath(key: MasterKey): string {
  return `/masters/${key}`;
}
